import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext';

const Home = () => {
    const navigate = useNavigate();
    const { config } = useConfig();
    const { user } = useAuth(); // kept in case needed later, though unused in the filter now

    const menuItems = [
        { label: 'AGENDA', path: '/agenda', icon: '📅', key: 'agenda' },
        { label: 'CONFERENCISTAS', path: '/speakers', icon: '🎙️', key: 'speakers' },
        { label: 'PREGUNTAS', path: '/questions-expert', icon: '💬', key: 'questions_private' },
        { label: 'PREGUNTAS INTERACTIVAS', path: '/interactiva', icon: '❓', key: 'interactiva' },
        { label: 'STREAMING', path: '/streaming', icon: '📺', key: 'streaming' },
        { 
            label: 'FOTOS', 
            path: '/event-gallery', 
            icon: '📸', 
            key: 'gallery',
            type: config?.pageDesigns?.gallery?.type,
            url: config?.pageDesigns?.gallery?.url
        },
    ].filter(item => {
        const design = config?.pageDesigns?.[item.key];
        return design ? design.enabled !== false : true;
    });

    return (
        <div className="flex flex-col items-center justify-center py-6 min-h-[60vh] animate-fadeIn">
            {/* Menu Buttons */}
            <div className="w-full max-w-sm space-y-4">
                {menuItems.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => {
                            if (item.type === 'redirect' && item.url) {
                                window.open(item.url, '_blank');
                            } else {
                                navigate(item.path);
                            }
                        }}
                        className="w-full btn-premium shadow-none border border-white/10 text-xl py-6"
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            {/* Optional Small Text */}
            <div className="mt-12 text-center opacity-80 text-white">
                <p className="text-[10px] font-black uppercase tracking-[0.5em]">Experiencia LATAM</p>
            </div>
        </div>
    );
};

export default Home;
